{
  "login": {
    "welcomeTitle": "Te damos la bienvenida",
    "welcomeSubtitle": "Inicia sesión en tu cuenta",
    "backHome": "Al inicio",
    "heroTitle": "Tu Camino de Luz continúa",
    "heroText": "Bienvenido de nuevo. Inicia sesión en tu cuenta para continuar tus prácticas, hablar con los Maestros y avanzar por el Camino de Luz. Nos alegra verte otra vez.",
    "statusPrefix": "Tu camino continúa — ",
    "statusName": "Inicia sesión",
    "formTitle": "Bienvenido de nuevo",
    "formText": "Continúa tu Camino de Luz. Descubre nuevas prácticas, encuentros y conocimientos.",
    "emailLabel": "Correo electrónico",
    "emailPlaceholder": "you@email.com",
    "passwordLabel": "Contraseña",
    "passwordPlaceholder": "••••••••",
    "forgotPassword": "¿Olvidaste tu contraseña?",
    "submit": "Iniciar sesión",
    "passkey": "Iniciar sesión con passkey",
    "passkeyUnavailable": "El inicio con passkey aún no está disponible. Usa email y contraseña.",
    "newToAgape": "¿No tienes cuenta?",
    "createAccount": "Crear cuenta",
    "errorCodeLabel": "Código de error",
    "errorCodeHint": "Dáselo al soporte: con él encuentran exactamente qué falló.",
    "errorCodeCopy": "Copiar código",
    "errorCodeCopied": "Código copiado"
  },
  "register": {
    "backHome": "A la página principal",
    "heroTitle": "Tu Camino de Luz comienza aquí",
    "heroTitlePlain": "Te damos la bienvenida a Agapella",
    "heroText": "Crea una cuenta para explorar prácticas, conocer a los Maestros de Ágape y a personas afines, encontrando poco a poco lo que te sostendrá en tu camino.",
    "statusPrefix": "Tu primer estatus — ",
    "statusName": "Buscador",
    "successNamePlain": "a Agapella",
    "formTitle": "Crear cuenta",
    "formText": "Por ahora basta con lo esencial.\nMás adelante podrás contar más sobre tus intereses.",
    "emailLabel": "Correo electrónico",
    "emailPlaceholder": "tu@email.com",
    "passwordLabel": "Contraseña",
    "passwordPlaceholder": "Mínimo 8 caracteres",
    "passwordHelper": "Mínimo 8 caracteres, una mayúscula y un número",
    "confirmPasswordLabel": "Confirmar contraseña",
    "generatePassword": "Generar una contraseña segura",
    "submit": "Comenzar el Camino de Luz",
    "submitPlain": "Crear cuenta",
    "retry": "Reintentar",
    "formError": "No se pudo crear la cuenta. Inténtalo de nuevo.",
    "alreadyHaveAccount": "¿Ya tienes una cuenta?",
    "signIn": "Iniciar sesión",
    "welcomeTitle": "Te damos la bienvenida,",
    "successLead": "Hoy comienza tu Camino de Luz.",
    "successLeadPlain": "Tu cuenta está lista.",
    "successText": "Explora la plataforma a tu ritmo, conoce nuevos saberes y personas; Agapella estará cerca para ayudarte a dar los primeros pasos.",
    "successButton": "Entrar al espacio de Agapella",
    "successNext": "Siguiente: conoce Agapella en la página principal",
    "togglePassword": "Mostrar u ocultar la contraseña",
    "or": "o",
    "signInWithApple": "Iniciar sesión con Apple",
    "resendConfirmation": "Reenviar correo de confirmación",
    "resending": "Enviando...",
    "resendSuccess": "Correo enviado. Revisa tu bandeja de entrada.",
    "checkMailTitle": "Revisa tu correo",
    "checkMailLead": "Enviamos un mensaje a {{email}}. Abre el enlace para confirmar tu dirección.",
    "checkMailHint": "¿No lo ves? Mira en Promociones y Spam.",
    "changeEmail": "Usar otra dirección",
    "resendIn": "Puedes reenviar en {{seconds}} s",
    "openInApp": "Abrir en la aplicación",
    "nativeTitle": "Crear cuenta",
    "nativeSubtitle": "Completa los datos para registrarte",
    "nameLabel": "Nombre",
    "confirmedTitle": "Correo confirmado",
    "confirmedLead": "La cuenta está activa. Inicia sesión para empezar.",
    "checkMailNative": "Hemos enviado un correo de confirmación a {{email}}. Sigue el enlace para activar tu cuenta."
  },
  "forgotPassword": {
    "overline": "RECUPERACIÓN",
    "title": "Encuentra Tu",
    "titleHighlight": "Camino",
    "subtitle": "Ingresa tu correo para recibir instrucciones de recuperación",
    "formTitle": "Restablecer contraseña",
    "formText": "Indica el correo con el que te registraste y te enviaremos un enlace para restaurar el acceso.",
    "emailLabel": "Correo Electrónico",
    "emailPlaceholder": "tu@presencia.com",
    "submit": "ENVIAR ENLACE DE RECUPERACIÓN",
    "remembered": "¿LO RECORDASTE?",
    "signIn": "INICIAR SESIÓN",
    "successTitle": "Revisa tu correo",
    "successMessage": "Hemos enviado un enlace de recuperación a",
    "successHint": "Sigue las instrucciones para restablecer tu contraseña.",
    "returnToLogin": "VOLVER AL INICIO DE SESIÓN",
    "tryAnother": "INTENTAR CON OTRO CORREO",
    "nativeTitle": "Recuperar contraseña",
    "nativeSubtitle": "Escribe tu email para recibir las instrucciones",
    "nativeSubmit": "Enviar instrucciones",
    "nativeSuccessText": "Si existe una cuenta con {{email}}, le hemos enviado las instrucciones para restablecer la contraseña.",
    "rememberedPassword": "¿Recordaste la contraseña?"
  },
  "resetPassword": {
    "overline": "SEGURIDAD",
    "title": "Nueva",
    "titleHighlight": "Contraseña",
    "subtitle": "Crea una contraseña segura para tu cuenta",
    "newPasswordLabel": "Nueva Contraseña",
    "newPasswordPlaceholder": "Crea una nueva contraseña",
    "confirmPasswordLabel": "Confirmar Contraseña",
    "confirmPasswordPlaceholder": "Repetir nueva contraseña",
    "submit": "CONFIRMAR RESTABLECIMIENTO",
    "cancelLabel": "¿CANCELAR?",
    "returnToLogin": "VOLVER AL INICIO DE SESIÓN",
    "expiredTitle": "Enlace Expirado",
    "expiredMessage": "Este enlace de restablecimiento de contraseña es inválido o ha expirado por razones de seguridad.",
    "requestNewLink": "SOLICITAR NUEVO ENLACE",
    "successTitle": "¡Listo!",
    "successMessage": "Tu contraseña ha sido actualizada exitosamente. Ahora puedes usar tus nuevas credenciales.",
    "goToLogin": "IR A INICIAR SESIÓN",
    "invalidTitle": "Enlace no válido",
    "invalidMessage": "El enlace para restablecer la contraseña caducó o es incorrecto. Pide uno nuevo.",
    "changedTitle": "Contraseña cambiada",
    "changedMessage": "Ya puedes iniciar sesión con tu nueva contraseña.",
    "orTypeOwn": "o escribe la tuya"
  },
  "confirmEmail": {
    "verifying": "Verificando tu e-mail…",
    "signIn": "INICIAR SESIÓN",
    "failedTitle": "Verificación fallida",
    "returnHome": "VOLVER AL INICIO",
    "alreadyTitle": "El correo ya está confirmado",
    "alreadyMessage": "No hay nada que hacer: solo inicia sesión.",
    "expiredTitle": "El enlace ha caducado",
    "expiredMessage": "Los enlaces duran 24 horas. Solicita un correo nuevo al mismo buzón.",
    "requestNew": "Solicitar un correo nuevo",
    "invalidTitle": "El enlace no funcionó",
    "invalidMessage": "Es posible que tu aplicación de correo lo haya recortado o que se haya copiado solo en parte. Solicita un correo nuevo: llegará a la misma dirección.",
    "backToSignIn": "Ya tengo una cuenta"
  },
  "validation": {
    "emailRequired": "El correo es obligatorio",
    "emailInvalid": "Formato de correo inválido",
    "passwordRequired": "La contraseña es obligatoria",
    "passwordMinLength": "La contraseña debe tener al menos 6 caracteres",
    "passwordWeak": "Mínimo 8 caracteres, una mayúscula y un dígito. Solo caracteres latinos",
    "confirmPasswordRequired": "Por favor confirma tu contraseña",
    "passwordsMismatch": "Las contraseñas no coinciden",
    "loginFailed": "Error al iniciar sesión. Por favor, inténtalo de nuevo.",
    "emailTaken": "Este correo ya está registrado.",
    "registerFailed": "Error en el registro. Por favor, inténtalo de nuevo.",
    "resetFailed": "Error al restablecer la contraseña. El enlace puede haber expirado.",
    "resetLinkInvalid": "Este enlace es inválido o ha expirado. Por favor solicita un nuevo restablecimiento de contraseña.",
    "verifyLinkInvalid": "El enlace de verificación es incorrecto o le faltan componentes necesarios.",
    "verifyFailed": "La verificación falló. El enlace puede haber expirado por razones de seguridad."
  },
  "apiErrors": {
    "invalidEmail": "Formato de correo inválido",
    "emailAlreadyExists": "Este correo ya está registrado.",
    "weakPassword": "La contraseña es demasiado débil. Mínimo 8 caracteres, una mayúscula y un dígito.",
    "registrationFailed": "Error en el registro. Por favor, inténtalo de nuevo.",
    "rateLimitExceeded": "Demasiados intentos. Espera un momento e inténtalo de nuevo.",
    "invalidSocialToken": "No se pudo verificar el inicio de sesión. Inténtalo de nuevo.",
    "invalidCredentials": "Correo o contraseña incorrectos.",
    "emailNotConfirmed": "Este correo aún no está confirmado. Revisa tu bandeja de entrada para el enlace de confirmación.",
    "accountBlocked": "El acceso a esta cuenta está cerrado. Escríbenos a info@agapella.io y lo resolvemos.",
    "consentRequired": "Para continuar, acepta las Condiciones de uso y la Política de privacidad.",
    "ageRequired": "Elige tu edad para continuar.",
    "ageNotAllowed": "El registro está disponible a partir de los 14 años."
  },
  "legal": {
    "consentPrefix": "Acepto los ",
    "loginPrefix": "Al iniciar sesión, aceptas los ",
    "terms": "Términos de uso",
    "consentMid": " y la ",
    "privacy": "Política de privacidad",
    "consentA11y": "Aceptar los Términos de uso y la Política de privacidad",
    "pdPrefix": "Al marcar esta casilla, acepto los ",
    "pdConsentMid": ", confirmo que los he leído y doy mi ",
    "pdConsent": "consentimiento para el tratamiento de datos personales",
    "pdPolicyMid": ". Más información sobre el tratamiento de datos en la ",
    "pdPolicy": "Política de privacidad",
    "pdSuffix": ".",
    "consentA11yPd": "Aceptar los Términos de uso y dar el consentimiento para el tratamiento de datos personales",
    "marketingConsent": "Doy mi consentimiento para recibir publicidad de JSC «Tsifrovaya II Transformatsiya»",
    "marketingConsentLink": "consentimiento para recibir publicidad",
    "zeroTolerance": "Tolerancia cero con el contenido ofensivo y los usuarios abusivos: revisamos cada denuncia en 24 horas, eliminamos el contenido y expulsamos a su autor.",
    "mustAccept": "Para continuar, acepta los Términos de uso y la Política de privacidad.",
    "mustAcceptPd": "Para continuar, acepta los Términos de uso y da tu consentimiento para el tratamiento de datos personales.",
    "close": "Cerrar"
  },
  "age": {
    "question18": "¿Cuántos años tienes?",
    "is18": "Tengo 18 o más",
    "below18": "Tengo menos de 18",
    "question14": "¿Tienes 14 años o más?",
    "is14": "Tengo 14 o más",
    "below14": "Tengo menos de 14",
    "back": "Atrás",
    "change": "Cambiar",
    "summaryAdult": "Edad: 18 o más",
    "summaryTeen": "Edad: de 14 a 17",
    "under14Title": "El registro está disponible a partir de los 14 años",
    "under14Body": "Cuidamos a los niños y no podemos crear una cuenta si tienes menos de 14 años. Vuelve cuando seas mayor: te estaremos esperando.",
    "required": "Elige tu edad para continuar"
  },
  "consentGate": {
    "title": "Un par de pasos antes de empezar",
    "body": "Indica tu edad y acepta los documentos: sin eso no podemos guardar tus datos.",
    "updateTitle": "Hemos actualizado los documentos",
    "updateBody": "Han cambiado las Condiciones de uso y el consentimiento para el tratamiento de datos personales. Para seguir usando Agapella, léelos y acéptalos; hasta entonces el acceso a tu cuenta está limitado.",
    "continue": "Continuar",
    "logout": "Cerrar sesión",
    "error": "No se pudo guardar. Revisa la conexión e inténtalo de nuevo.",
    "under14Removed": "La cuenta se ha eliminado: el registro está disponible a partir de los 14 años."
  }
}
